'use strict';

var React = require('react');

var PropTypes = require('prop-types');

module.exports = function render(props) {
  var innerHtml = '<path d="M12.714 11.33a.984.984 0 0 1 0 1.387.978.978 0 0 1-1.377 0L6.5 7.883l-4.838 4.834a.976.976 0 0 1-1.377 0 .984.984 0 0 1 0-1.387l4.836-4.834L.286 1.663a.972.972 0 0 1 0-1.377.972.972 0 0 1 1.376 0L6.5 5.119 11.337.286a.973.973 0 1 1 1.377 1.377L7.878 6.496l4.836 4.834z"/><!-- Filename: sourceSvg/action/close.svg -->';
  var svgProps = {
    className: props.className ? props.className + ' uig-svg-icon' : 'uig-svg-icon',
    dangerouslySetInnerHTML: {
      __html: innerHtml
    },
    viewBox: '0 0 13 13'
  };
  return React.createElement('svg', Object.assign({}, props, svgProps));
};